export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8559.047180c8.jpg";